<template>
  <div class="signup" style="position: absolute;height: 100%;background: #f3f3f3;" v-wechat-title="$route.meta.title">
    <div class="bannerSignup" >
      <img :src="url" alt class>
      <img v-if="!url"  src="../../assets/images/bmBg.jpg" />
    </div>
    <div class="inputBox">
      <h2>会议报名查询</h2>
      <div class="inputCont" style="padding-top:35px">
        <div class="inputkuang">
          <dl>
            <dt>报名人姓名<sup>*</sup></dt>
            <dd><input type="text" v-model="params.name" placeholder="请输入报名人姓名" /></dd>
          </dl>
          <dl>
            <dt>报名人手机<sup>*</sup></dt>
            <dd><textarea v-model="params.mobile" placeholder="请输入报名人手机"></textarea></dd>
          </dl>
          <dl>
            <dt>验证码<sup>*</sup></dt>
            <dd>
              <van-field
                v-model.trim="code"
                clearable
                placeholder="请输入验证码"
              ></van-field>

              <div @click="refreshCode" class="vacDiv">
                <div>
                  <v-sidentify :identifyCode="identifyCode"></v-sidentify>
                </div>
                <span>看不清？换一张</span>
              </div>
            </dd>
          </dl>
          <div class="boxSerch">
            <van-divider>查询结果</van-divider>
            <div v-if="show == 1">
              <van-icon name="checked" color="#00cc74" size="2rem"/>
              <p style="margin-top:20px">您已成功报名</p>
            </div>
            <div v-if="show == 2">
              <van-icon name="clear"  color="red" size="2rem"/>
              <p style="margin-top:20px">未找到该信息，请您去报名</p>
            </div>
          </div>
          <div class="buttonDiv">
            <van-button type="primary" block  class="but1" @click="search()">提交查询</van-button>
            <van-button type="primary" block @click="goSearch">我要报名</van-button>
          </div>
        </div>
      </div>
      <p class="fontSizeDiv">
        技术支持：智联软件
      </p>
    </div>
  </div>
</template>
<script>
import {getRegisterMeetingDetail,getPZUrl,getMeetingDetail } from "@/api/dictionary";
import { Icon, Row, Col, Button, Swipe, SwipeItem, Dialog,Divider,Field,Toast } from "vant";
import { getSessionStore } from "../../utils/sessionStorage.js";
import { mapGetters, mapState, mapActions } from "vuex";
import Sidentify from "../../components/VerificationCode"; //**引入验证码组件**
export default {
  data() {
    return {
      type: "1",
      show:null,
      code:null,
      tipContent: "",
      url: "",
      meetingDetail:{},
      title:'',
      params:{
        name:null,
        mobile:null,
        meetingId:null
      },
      identifyCode: "",
      identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz",
    };
  },
  components: {
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [Dialog.name]: Dialog,
    [Divider.name]:Divider,
    [Field.name]: Field,
    [Toast.name]:Toast,
    "v-sidentify": Sidentify,
  },
  computed:{
		meetingId(){
			return this.$route.query&&this.$route.query.meetingId;
	},
},
  methods: {
      goSearch(){
         this.$router.push({ name: 'signup',query:{meetingId:this.meetingId}});
      },
      getPZUrl() {
        let params = {
          id: this.meetingDetail.photoId
        };
        getPZUrl(params).then(res => {
          this.url = res.result;
        });
      },
      search(){
        if(!this.params.name){
          Toast("姓名不能为空");
          return;
        }
        if(!this.params.mobile){
          Toast("手机号码不能为空");
          return;
        }
        if(!this.code){
          Toast("验证码不能为空");
          return;
        }
        if (this.code.toLowerCase() !== this.identifyCode.toLowerCase()) {
          Toast("验证码不正确");
          return;
        }
        getRegisterMeetingDetail(this.params)
        .then(res=>{
          this.tipContent = ''
          if(res.success){
            this.show = 1;
          }else{
            if(res.messageCode == '600001'){
                this.show = 2;
             }else if(res.messageCode == '600002'){
               this.show = 1;
             }else{
               Toast.fail("查询失败")
             }
          }
        })
      },
    // 重置验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    getMeetingDetail(){
      getMeetingDetail({ meetingId:this.params.meetingId}).then((res) => {
        if (res.success) {
          this.meetingDetail = res.result.meetingDTO;
          this.$route.meta.title = res.result.meetingDTO.name;
          if(res.result.meetingDTO.photoId){
            this.getPZUrl();
          }
        }
      });
    }
  },
  mounted() {
    if(!this.params.meetingId){
      this.params.meetingId = this.meetingId;
    }
    this.getMeetingDetail();
    // 初始化验证码
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  }
};
</script>
